<div class="system-message">

  <!-- ============================================================ -->
  <!-- Header strip — Notification Type + Client selector          -->
  <!-- ============================================================ -->
  <div class="system-message-hdr gt-filter-container">
    <div class="title-block">
      <i class="fa fa-envelope-o" aria-hidden="true"></i>
      <b>{{ title }}</b>
    </div>

    <div class="gt-filter-item type-pills">
      <label class="filter-label">Notification Type:</label>
      <ul class="tab tab-pills">
        <li (click)="setNotifType('system')">
          <a [ngClass]="{ activeTab: notifSelectedTypeVal === 'system', inactiveTab: notifSelectedTypeVal !== 'system' }">System</a>
        </li>
        <li (click)="setNotifType('client')">
          <a [ngClass]="{ activeTab: notifSelectedTypeVal === 'client', inactiveTab: notifSelectedTypeVal !== 'client' }">Client</a>
        </li>
      </ul>
    </div>

    @if (notifSelectedTypeVal === 'client') {
      <div class="gt-filter-item">
        <label class="filter-label">Client:</label>
        <select class="gt-filter-select"
          [(ngModel)]="selectedClient"
          (ngModelChange)="changeClientType()"
          [compareWith]="compareClient">
          <option [ngValue]="null">Select Client</option>
          @for (client of clients; track client) {
            <option [ngValue]="client">{{ client.client_name }}</option>
          }
        </select>
      </div>
    }
  </div>

  <!-- ============================================================ -->
  <!-- Body — left rail + right panel                              -->
  <!-- ============================================================ -->
  <div class="system-notif-list-wrpr">

    <!-- ====== LEFT RAIL ====== -->
    <aside class="system-notifications">
      <div class="search-content">
        <div class="input-wrapper">
          <i class="fa fa-search" aria-hidden="true"></i>
          <input type="text"
            class="form-control"
            placeholder="Search notifications..."
            [(ngModel)]="searchNotif" />
          </div>
          <div class="pencil-wrapper"
            ap-tooltip [appendAfterTarget]="true" tooltipContent="Create New System Message"
            direction="bottom"
            role="button"
            tabindex="0"
            (click)="createNotifListData()"
            (keydown.enter)="createNotifListData()">
            <i class="fa fa-pencil" aria-hidden="true"></i>
          </div>
          <div class="filter-select-wrpr">
            <select class="form-control"
              [(ngModel)]="selectedMsgFilterVal"
              (ngModelChange)="messageFilter()">
              <option value="show all">Show All</option>
              <option value="archive">Archive</option>
            </select>
          </div>
        </div>

        <div class="notification-list">
          @if (showNotifLoader) {
            <div class="list-empty">
              <i class="fa fa-spinner fa-pulse fa-2x"></i>
            </div>
          }

          @if (!showNotifLoader && filteredLeftList().length === 0) {
            <div class="list-empty">
              <h4>No Notifications</h4>
            </div>
          }

          @for (notifList of filteredLeftList(); track trackByMsgKey($index, notifList)) {
            <div
              class="each-notif-list"
              [class.set-background]="notifList.selected"
              (click)="editNotifListData(notifList)">
              <div class="row-top">
                <span class="text-wrapper"
                  ap-tooltip [appendAfterTarget]="true" [tooltipContent]="notifList.notif_msg_title"
                  direction="top">
                  {{ notifList.notif_msg_title }}
                </span>
                <span class="list-action archive-action"
                  ap-tooltip [appendAfterTarget]="true" [tooltipContent]="notifList.notif_status === 'closed' ? 'Unarchive' : 'Archive'"
                  direction="left"
                  role="button"
                  tabindex="0"
                  (click)="archiveList(notifList, $event)"
                  (keydown.enter)="archiveList(notifList, $event)">
                  <i class="fa fa-file-archive-o" aria-hidden="true"></i>
                </span>
                <span class="list-action edit-action"
                  ap-tooltip [appendAfterTarget]="true" tooltipContent="Edit Message"
                  direction="left">
                  <i class="fa fa-external-link" aria-hidden="true"></i>
                </span>
              </div>
              <div class="row-meta">
                <span class="meta-author">{{ notifList.created_by }}</span>
                <span class="meta-date">{{ notifList.updated_on }}</span>
              </div>
            </div>
          }
        </div>
      </aside>

      <!-- ====== RIGHT PANEL ====== -->
      <section class="system-message-data">
        @if (!showSystemMessageContent) {
          <div class="empty-state">
            <h3>No System Message to display</h3>
            <h4>Click the pencil icon to create a new message or select an existing one to edit.</h4>
          </div>
        }

        @if (showSystemMessageContent) {
          <div>
            <!-- ====== Message settings panel ====== -->
            <div class="panel panel-default">
              <div class="panel-heading"><b>{{ createSystemMessageHdr }} Message settings:</b></div>
              <div class="panel-body">
                <div class="settings-grid">
                  <!-- Left column -->
                  <div class="settings-col">
                    <div class="field-row">
                      <label>Select Start Date:</label>
                      <input type="date"
                        class="form-control"
                        name="start_date"
                        [(ngModel)]="selectedSysMsgData.notif_start_date" />
                        @if (submitted && !selectedSysMsgData.notif_start_date) {
                          <span class="form-error-container"
                            >
                            Start Date is required.
                          </span>
                        }
                      </div>
                      <div class="field-row">
                        <label>User Type:</label>
                        <select class="form-control"
                          name="user_type"
                          [(ngModel)]="userTypeValue">
                          <option [ngValue]="null">Select</option>
                          @for (userType of userTypes; track userType) {
                            <option [ngValue]="userType.value">
                              {{ userType.name }}
                            </option>
                          }
                        </select>
                      </div>
                      <div class="field-row">
                        <label>Users:</label>
                        <div class="user-search-wrpr">
                          <input type="text"
                            class="form-control"
                            placeholder="search for users..."
                            [(ngModel)]="searchUserText"
                            (ngModelChange)="searchUserList()" />
                            <span class="search-icon"><i class="fa fa-search"></i></span>
                            @if (searchUserText && searchUserText.length >= 3 && searchResults.length > 0) {
                              <div class="user-drp-menu"
                                >
                                <ul>
                                  @for (user of searchResults; track user) {
                                    <li
                                      (click)="selectedUser(user)">
                                      {{ user.DISPLAY_NAME }}
                                    </li>
                                  }
                                </ul>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      <!-- Right column -->
                      <div class="settings-col">
                        <div class="field-row">
                          <label>Select End Date:</label>
                          <input type="date"
                            class="form-control"
                            name="end_date"
                            [(ngModel)]="selectedSysMsgData.notif_end_date" />
                            @if (submitted && !selectedSysMsgData.notif_end_date) {
                              <span class="form-error-container"
                                >
                                End Date is required.
                              </span>
                            }
                          </div>
                          <div class="field-row">
                            <label>App Key:</label>
                            <ap-dropdown class="ms-control"
                              [list]="dropdownLists.appKey"
                              [(ngModel)]="appKeySelected"
                              [selectType]="'multiple'"
                              [enableNgContent]="false"
                              [optionName]="'LABEL'"
                              [optionValue]="'__dropdownKey'"
                              [title]="'Select App Key'"
                              [inputAriaLabel]="'App Key'"
                              [hideTitleOnInput]="true"
                              [showSearchbox]="true"
                              [showSelectAll]="true"
                              [clearSearchKeyword]="true"
                              (onFilterResult)="onDropdownFilterResult('appKey', $event)">
                            </ap-dropdown>
                          </div>
                          <div class="field-row">
                            <label>Tax Type:</label>
                            <ap-dropdown class="ms-control"
                              [list]="dropdownLists.taxType"
                              [(ngModel)]="taxTypeSelected"
                              [selectType]="'multiple'"
                              [enableNgContent]="false"
                              [optionName]="'LABEL'"
                              [optionValue]="'__dropdownKey'"
                              [title]="'Select Tax Type'"
                              [inputAriaLabel]="'Tax Type'"
                              [hideTitleOnInput]="true"
                              [showSearchbox]="true"
                              [showSelectAll]="true"
                              [clearSearchKeyword]="true"
                              (onFilterResult)="onDropdownFilterResult('taxType', $event)">
                            </ap-dropdown>
                          </div>
                          @if (notifSelectedTypeVal === 'client') {
                            <div class="field-row">
                              <label>Clients:</label>
                              <ap-dropdown class="ms-control"
                                [list]="dropdownLists.client"
                                [(ngModel)]="clientListSelected"
                                [selectType]="'multiple'"
                                [enableNgContent]="false"
                                [optionName]="'client_name'"
                                [optionValue]="'client_key'"
                                [title]="'Select Clients'"
                                [inputAriaLabel]="'Clients'"
                                [hideTitleOnInput]="true"
                                [showSearchbox]="true"
                                [showSelectAll]="true"
                                [clearSearchKeyword]="true"
                                (onFilterResult)="onDropdownFilterResult('client', $event)">
                              </ap-dropdown>
                              @if ((submitted || customValidations)
                                && notifSelectedTypeVal === 'client'
                                && (clientListSelected?.length || 0) === 0) {
                                <span class="form-error-container"
                                  >
                                  Client is required.
                                </span>
                              }
                            </div>
                          }
                        </div>
                      </div>
                      <!-- Selected users chip list -->
                      @if (selectedUserList.length > 0) {
                        <div class="users-chip-row">
                          <label>Users list:</label>
                          <ul class="user-list">
                            @for (userItem of selectedUserList; track userItem; let i = $index) {
                              <li
                                class="user-item">
                                <span class="user-icn"><i class="fa fa-user-circle-o" aria-hidden="true"></i></span>
                                <span class="user-name">{{ userItem.DISPLAY_NAME }}</span>
                                <span class="dlt-user"
                                  ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove user"
                                  direction="top"
                                  role="button"
                                  tabindex="0"
                                  (click)="deleteUser(i)"
                                  (keydown.enter)="deleteUser(i)">
                                  <i class="fa fa-times" aria-hidden="true"></i>
                                </span>
                              </li>
                            }
                          </ul>
                        </div>
                      }
                    </div>
                  </div>
                  <!-- ====== Message details panel ====== -->
                  <div class="panel panel-default">
                    <div class="panel-heading"><b>{{ createSystemMessageHdr }} Message Details:</b></div>
                    <div class="panel-body">
                      <div class="field-row">
                        <label>System Message title:</label>
                        <input type="text"
                          class="form-control"
                          name="message_title"
                          [(ngModel)]="selectedSysMsgData.notif_msg_title" />
                          @if (submitted && !selectedSysMsgData?.notif_msg_title) {
                            <span class="form-error-container"
                              >
                              System Message Title is required.
                            </span>
                          }
                        </div>
                        <div class="field-row body-row">
                          <label>System Message Body:</label>
                          <ap-text-editor
                            [styleClass]="'sys-message-body-editor'"
                            [style]="'background: white; display: block;'"
                            [(data)]="notifMsgBody"
                            [config]="editorConfig">
                          </ap-text-editor>
                          @if ((submitted || customValidations) && isBodyEmpty()) {
                            <span class="form-error-container"
                              >
                              System Message Body is required.
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    <!-- ====== Footer ====== -->
                    <div class="message-ftr">
                      <button class="btn btn-success btn-sm"
                        type="button"
                        [disabled]="saving"
                        (click)="saveDetails()">
                        @if (saving) {
                          <i class="fa fa-spinner fa-pulse"></i>
                        }
                        Save Details
                      </button>
                    </div>
                  </div>
                }
              </section>
            </div>
          </div>
